/**
 * Shared constants for VeilBrowser
 */

// Platform-admin vocabulary: staff roles, permissions, audit action names.
export * from "./admin.ts";

// ============ Browser Version Constraints ============

/** Minimum supported browser version */
export const BROWSER_VERSION_MIN = 135;

/**
 * Maximum supported browser version.
 *
 * Deliberately far above any shipping Chromium major so new majors do not
 * require a code change. Whether a given version is usable is decided by
 * what is installed on disk (see local-api `version-resolver.ts`), which
 * reports BROWSER_VERSION_NOT_INSTALLED with the available versions.
 */
export const BROWSER_VERSION_MAX = 1000;

// ============ Profile Constants ============

/** Profile file extension */
export const PROFILE_EXTENSION = ".enc";

// ============ API Constants ============

/** Default API port */
export const DEFAULT_API_PORT = 3000;

/** Default debug port for browser */
export const DEFAULT_DEBUG_PORT = 9222;

// ============ OS Patterns ============

/**
 * Map API OS values to profile file name patterns
 * Profile files are named like: chrome143_win10_x64.enc, chrome143_mac_arm64.enc
 */
export const OS_PATTERNS: Record<string, string[]> = {
	win: ["windows", "win"],
	mac: ["mac", "macos", "darwin"],
	linux: ["linux", "ubuntu", "debian"],
	android: ["android"],
};

/**
 * Map architecture patterns to normalized arch values
 */
export const ARCH_PATTERNS: Record<string, string[]> = {
	x64: ["x64", "x86_64", "amd64", "64bit"],
	x86: ["x86", "i386", "i686", "32bit"],
	arm64: ["arm64", "aarch64"],
	unknown: [],
};
